import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import HelloWorld2 from '@/components/Hello2';
import Help from '@/components/Help';
import HelpCertificate from '@/components/HelpCertificate';
import Index2 from '@/components/Index2';
import Solutions from '@/components/Solutions';
import PersonalSignerMac from '@/components/PersonalSignerMac';
import HeaderApp from '@/components/HeaderApp';
import HeaderApp2 from '@/components/HeaderApp2';
import FooterApp from '@/components/FooterApp';
import UploadCert from '@/components/UploadCert';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index2',
      components: {
        header:HeaderApp2,
        default: Index2,
        footer: FooterApp
      }      
    },
    {
      path: '/help',
      name: 'Help',
      components: {
        header:HeaderApp2,
        default: Help,
        footer: FooterApp
      }   
     },    
    {
      path: '/hello2',
      name: 'HelloWorld2',
      components: {
        header:HeaderApp2,
        default: HelloWorld2,
        footer: FooterApp
      }
    },  
    {
      path: '/helpcertificate',
      name: 'HelpCertificate',
      components: {
        default: HelpCertificate,
        footer: FooterApp
      }
    },    
    {
      path: '/helpcertificate2',
      name: 'HelpCertificate2',
      components: {
        header:HeaderApp2,
        default: HelpCertificate,
        footer: FooterApp
      }
    }, 
    {
      path: '/index2',
      name: 'Index2',
      components: {
        header:HeaderApp2,
        default: Index2,
        footer: FooterApp
      }
    },
    {
      path: '/solutions',
      name: 'Solutions',
      components: {
        header:HeaderApp2,
        default: Solutions,
        footer: FooterApp
      }
    } ,
    {
      path: '/psmacs',
      name: 'Psmac',
      components: {
        header:HeaderApp2,
        default: PersonalSignerMac,
        footer: FooterApp
      }
    } ,
    
    {
      path: '/uploadcert',
      name: 'Uploaadcert',
      components: {
        header:HeaderApp2,
        default: UploadCert,
        footer: FooterApp
      }
    }     
  ]
});
